import { Market } from '../../types/shared/Market';
import { VendorAddons, Field } from '../../types/shared/Vendor';

import { getAttendingDates } from './getAttendingDates';
import IndexedList from './IndexedList';

export function calculateAddonDates(
  addons: VendorAddons,
  market: Market,
  fields: IndexedList<Field>,
): Array<string> {
  let { id } = market;
  let status = addons?.status || 'No';
  if (status === 'No') {
    return [];
  }
  let attendingDates = getAttendingDates(market, fields);
  if (status === 'Yes') {
    return attendingDates;
  }
  // For status "Partial" we'll validate the selected addon dates against the
  // list of dates this vendor is scheduled to attend.
  let selectedAddonDates = new Set(Object.keys(addons.dates[id] || {}));
  return attendingDates.filter((date) => selectedAddonDates.has(date));
}
